import { classesBuilder } from '@common/helpers';

import BaseButton from './BaseButton';
import type { IButtonProps } from './types';

import style from './styles.module.scss';

// NOTE: Temporary button component until we have a final design
export const Button = ({
  buttonType = 'primary',
  variant = 'filled',
  icon,
  children,
  className,
  ...props
}: IButtonProps) => {
  return (
    <BaseButton
      className={classesBuilder(style.button, style[`${buttonType}-${variant}`], className)}
      {...props}
    >
      {icon && <span>{icon}</span>}
      {children}
    </BaseButton>
  );
};
export default Button;
